import { Outlet } from 'react-router-dom';
import styles from './index.module.scss';
import Sidebar from '../Sidebar';
import ContentArea from '../ContentArea';

const MaterialManageLayout = () => {
    return (
        <div className={styles.MaterialManageLayout}>
            <div className={styles.sidebarWrap}>
                <Sidebar />
            </div>
            <div className={styles.contentWrap}>
                <ContentArea />
            </div>
        </div>
    );
};

export default MaterialManageLayout;